export { Faq } from './faq';
